import type { GeneralFieldOptionPopupProps } from "../../../common/fields/types/generalFieldOptionPopup.types";
import GeneralFieldOptionPopup from "../columns/GeneralFieldOptionPopup";

const RowFieldOptionPopup = (props: GeneralFieldOptionPopupProps) => {
  return (
    <GeneralFieldOptionPopup {...props} supportedDateGroupings={props.field.meta.options?.supportedColumnGrouping} />
  );
};

export default RowFieldOptionPopup;
